import { Table } from 'antd';
import '../../../sass/pages/_dashboard.scss';
import { TableColumns, tableColumns } from './csv_data';
import { ListingImportProps } from './Import.types';

export const ListingImportData = ({ loading, data, action }: ListingImportProps) => {
  const columns = tableColumns[action as keyof TableColumns];

  return (
    <Table
      loading={loading}
      className="table"
      columns={columns}
      dataSource={data}
      rowKey={({ sku }) => sku}
      pagination={{ defaultPageSize: 50 }}
    />
  );
};
